import { render, staticRenderFns } from "./img-item.vue?vue&type=template&id=8b4cbbd6"
import script from "./img-item.vue?vue&type=script&lang=js"
export * from "./img-item.vue?vue&type=script&lang=js"
import style0 from "./img-item.vue?vue&type=style&index=0&id=8b4cbbd6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports